module.exports = __webpack_public_path__ + "img/2.3fe84854.png";